import { render, staticRenderFns } from "./FudaoHistory.vue?vue&type=template&id=67df5cca&scoped=true&"
import script from "./FudaoHistory.vue?vue&type=script&lang=js&"
export * from "./FudaoHistory.vue?vue&type=script&lang=js&"
import style0 from "./FudaoHistory.vue?vue&type=style&index=0&id=67df5cca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df5cca",
  null
  
)

export default component.exports